<div class="input-group">
    

    <ng-select class="ng-autocomplete"
        [items]="data"
        [bindLabel]="options.searchKeyword"
        [placeholder]="options.placeholder"
        [loading]="isLoadingResult"
        [typeahead]="typeahead$"
        [minTermLength]="options.minQueryLength"
        [disabled]="disabled"
        [virtualScroll]="true"
        [(ngModel)]="selectedItem"
        (change)="onSelect($event)"
        (focus)="onFocus()"
        appendTo="body">

        <ng-template ng-option-tmp let-item="item">
            <div *ngIf="options.groupHeaderField" class="mb-1">
                <mark class="ms-2 item-group-header"
                    [innerHTML]="item[options.groupHeaderField]">
                </mark>
            </div>
            <div class="row mt-1 ms-2">
                <div *ngFor="let field of options.templateFields"
                    class="text-truncate"
                    [ngClass]="'col-' + (12 / (options.templateFields?.length || 1))">
                    <small class="text-muted">{{ field.colName | titlecase }}</small>
                    <div>{{ item[field.fieldName] }}</div>
                </div>
            </div>
        </ng-template>

        <ng-template ng-notfound-tmp>
            <div class="p-2 bg-light font-weight-bold" *ngIf="data.length === 0">
                Record not found!
            </div>
        </ng-template>
    </ng-select>
</div>
